export default {
  paymentList: [],
  loading: false
}
